import { reactive } from 'vue'
export const State = {
	user:{},
	chater:{},
}
export function createState() {
	let _userInfo = localStorage.getItem('qx2userInfo');
	if (_userInfo) {
		_userInfo = JSON.parse(_userInfo);
		Object.assign(State.user, _userInfo);
	}
	return reactive(State)
}
